if (!window.productPriceProtectionPopoverBound) {
  window.productPriceProtectionPopoverBound = true;

  document.addEventListener('click', (event) => {
    document
      .querySelectorAll('.product-price-design__protection-info[open]')
      .forEach((popover) => {
        if (!popover.contains(event.target)) {
          popover.removeAttribute('open');
        }
      });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document
      .querySelectorAll('.product-price-design__protection-info[open]')
      .forEach((popover) => {
        popover.removeAttribute('open');
        popover.querySelector('summary')?.focus();
      });
  });
}
